import { useCallback, useEffect, useRef } from 'react';

export function useInterval(
  callback: () => void,
  delay: number | null
) {
  const savedCallback = useRef<() => void>();
  const intervalId = useRef<number | null>(null);

  // Always keep latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const start = useCallback(() => {
    if (intervalId.current !== null || delay === null) return;

    intervalId.current = window.setInterval(() => {
      savedCallback.current?.();
    }, delay);
  }, [delay]);

  const stop = useCallback(() => {
    if (intervalId.current !== null) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  }, []);

  const toggle = useCallback(() => {
    if (intervalId.current === null) {
      start();
    } else {
      stop();
    }
  }, [start, stop]);

  // Cleanup on unmount
  useEffect(() => {
    return stop;
  }, [stop]);

  return { start, stop, toggle, active: intervalId.current !== null };
}